module.exports = __webpack_public_path__ + "static/img/lixianrenwu.3ab80fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/lixianrenwu.png
// module id = H89S
// module chunks = 24